import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#060709]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo.png" alt="Clear Path Repair" className="h-10 w-auto object-contain" />
            <div className="leading-none">
              <span className="block font-serif text-lg tracking-tight text-white">Clear Path</span>
              <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Repair</span>
            </div>
          </div>

        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold mb-5">Navigate</p>
          <div className="flex flex-col gap-3 text-sm">
            <Link to="/pricing" className="text-slate-400 hover:text-white transition-colors">Pricing</Link>
            <Link to="/funding" className="text-slate-400 hover:text-white transition-colors">Funding</Link>
            <Link to="/testimonials" className="text-slate-400 hover:text-white transition-colors">Testimonials</Link>
            <Link to="/about" className="text-slate-400 hover:text-white transition-colors">About</Link>
            <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">Book a Call</Link>
            <Link to="/login" data-testid="footer-admin-link" className="text-slate-500 hover:text-gold transition-colors">Admin Login</Link>
          </div>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold mb-5">Contact</p>
          <div className="flex flex-col gap-3 text-sm text-slate-400">
            <span className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /> (727) 855-7612</span>
            <span className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> clearpathrepair.enterprise@gmail.com</span>
            <span className="flex items-center gap-2"><MapPin className="w-4 h-4 text-gold" /> HQ: Tampa, Florida</span>
            <span className="flex items-center gap-2"><MapPin className="w-4 h-4 text-gold" /> HQ: Washington, DC</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-500 font-mono">
          <span>© 2026 Clear Path Repair LLC. All rights reserved.</span>
          <span>CROA Compliant · Results vary by individual credit profile</span>
        </div>
      </div>
    </footer>
  );
}
